"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var whatwgURL = require("whatwg-url");

var _require = require("../helpers/document-base-url"),
    parseURLToResultingURLRecord = _require.parseURLToResultingURLRecord;

exports.implementation =
/*#__PURE__*/
function () {
  function HTMLHyperlinkElementUtilsImpl() {
    _classCallCheck(this, HTMLHyperlinkElementUtilsImpl);
  }

  _createClass(HTMLHyperlinkElementUtilsImpl, [{
    key: "_htmlHyperlinkElementUtilsSetup",
    value: function _htmlHyperlinkElementUtilsSetup() {
      this.url = null;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.href;
    }
  }, {
    key: "href",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null) {
        var href = this.getAttribute("href");
        return href === null ? "" : href;
      }

      return whatwgURL.serializeURL(url);
    },
    set: function set(v) {
      this.setAttribute("href", v);
    }
  }, {
    key: "origin",
    get: function get() {
      reinitializeURL(this);

      if (this.url === null) {
        return "";
      }

      return whatwgURL.serializeURLOrigin(this.url);
    }
  }, {
    key: "protocol",
    get: function get() {
      reinitializeURL(this);

      if (this.url === null) {
        return ":";
      }

      return this.url.scheme + ":";
    },
    set: function set(v) {
      reinitializeURL(this);

      if (this.url === null) {
        return;
      }

      whatwgURL.basicURLParse(v + ":", {
        url: this.url,
        stateOverride: "scheme start"
      });
      updateHref(this);
    }
  }, {
    key: "username",
    get: function get() {
      reinitializeURL(this);

      if (this.url === null) {
        return "";
      }

      return this.url.username;
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.host === null || url.host === "" || url.cannotBeABaseURL || url.scheme === "file") {
        return;
      }

      whatwgURL.setTheUsername(url, v);
      updateHref(this);
    }
  }, {
    key: "password",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null) {
        return "";
      }

      return url.password;
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.host === null || url.host === "" || url.cannotBeABaseURL || url.scheme === "file") {
        return;
      }

      whatwgURL.setThePassword(url, v);
      updateHref(this);
    }
  }, {
    key: "host",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.host === null) {
        return "";
      }

      if (url.port === null) {
        return whatwgURL.serializeHost(url.host);
      }

      return whatwgURL.serializeHost(url.host) + ":" + whatwgURL.serializeInteger(url.port);
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.cannotBeABaseURL) {
        return;
      }

      whatwgURL.basicURLParse(v, {
        url: url,
        stateOverride: "host"
      });
      updateHref(this);
    }
  }, {
    key: "hostname",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.host === null) {
        return "";
      }

      return whatwgURL.serializeHost(url.host);
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.cannotBeABaseURL) {
        return;
      }

      whatwgURL.basicURLParse(v, {
        url: url,
        stateOverride: "hostname"
      });
      updateHref(this);
    }
  }, {
    key: "port",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.port === null) {
        return "";
      }

      return whatwgURL.serializeInteger(url.port);
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.host === null || url.host === "" || url.cannotBeABaseURL || url.scheme === "file") {
        return;
      }

      if (v === "") {
        url.port = null;
      } else {
        whatwgURL.basicURLParse(v, {
          url: url,
          stateOverride: "port"
        });
      }

      updateHref(this);
    }
  }, {
    key: "pathname",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null) {
        return "";
      }

      if (url.cannotBeABaseURL) {
        return url.path[0];
      }

      return "/" + url.path.join("/");
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.cannotBeABaseURL) {
        return;
      }

      url.path = [];
      whatwgURL.basicURLParse(v, {
        url: url,
        stateOverride: "path start"
      });
      updateHref(this);
    }
  }, {
    key: "search",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.query === null || url.query === "") {
        return "";
      }

      return "?" + url.query;
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null) {
        return;
      }

      if (v === "") {
        url.query = null;
      } else {
        var input = v[0] === "?" ? v.substring(1) : v;
        url.query = "";
        whatwgURL.basicURLParse(input, {
          url: url,
          stateOverride: "query",
          encodingOverride: this._ownerDocument.charset
        });
      }

      updateHref(this);
    }
  }, {
    key: "hash",
    get: function get() {
      reinitializeURL(this);
      var url = this.url;

      if (url === null || url.fragment === null || url.fragment === "") {
        return "";
      }

      return "#" + url.fragment;
    },
    set: function set(v) {
      reinitializeURL(this);
      var url = this.url;

      if (url === null) {
        return;
      }

      if (v === "") {
        url.fragment = null;
      } else {
        var input = v[0] === "#" ? v.substring(1) : v;
        url.fragment = "";
        whatwgURL.basicURLParse(input, {
          url: url,
          stateOverride: "fragment"
        });
      }

      updateHref(this);
    }
  }]);

  return HTMLHyperlinkElementUtilsImpl;
}();

function reinitializeURL(hheu) {
  if (hheu.url !== null && hheu.url.scheme === "blob" && hheu.url.cannotBeABaseURL) {
    return;
  }

  setTheURL(hheu);
}

function setTheURL(hheu) {
  var href = hheu.getAttribute("href");

  if (href === null) {
    hheu.url = null;
    return;
  }

  var parsed = parseURLToResultingURLRecord(href, hheu._ownerDocument);
  hheu.url = parsed === null ? null : parsed;
}

function updateHref(hheu) {
  hheu.setAttribute("href", whatwgURL.serializeURL(hheu.url));
}